class HttpError extends Error {
  constructor(status, message) {
    super(message);

    this.name = 'HttpError';
    this.status = status;
    this.message = message;

    Object.setPrototypeOf(this, HttpError.prototype);
  }
}

export default HttpError;



// WEBPACK FOOTER //
// ./src/classes/HttpError.js